import {Injector} from '@angular/core';

import {finalize, takeUntil} from 'rxjs/operators';

import {
    ArticleDto,
    BasketArticleDto,
    PagedResultDtoOfArticleDto,
    WebShopServiceProxy
} from '@shared/service-proxies/service-proxies';

import {PrimengTableHelper} from '@axilla/axilla-shared';
import {AppComponentBase} from '@shared/common/app-component-base';
import {Observable, Subject, throwError} from '@node_modules/rxjs';
import _ from 'lodash';
import {CombineViewService} from '@app/webshop/shared/services/combine-view.service';
import {ViewMode} from '../models';
import {BasketArticleExtendedDto} from '@app/shared/common/shop-system/models/models';
import { BasePermissionDefinition } from '@shared/permission/base-permission-definition';

export abstract class WebShopBaseComponent extends AppComponentBase {
    //default rows per pagesfor primeng tables or dataviews
    rowsPerPageOptions: number[] = [12, 24, 48];
    globalProducts: BasketArticleDto[];
    primeng: PrimengTableHelper;
    //Display rows amount per page
    rowsAmount: number;
    protected readonly ViewMode = ViewMode;
    protected webShopServiceProxy: WebShopServiceProxy;
    protected _combineViewService: CombineViewService;
    protected readonly destroy$ = new Subject<void>(); // Used to signal unsubscription
    private rowsAmount$: Observable<number>;

    protected readonly BasePermissionDefinition = BasePermissionDefinition;

    constructor(injector: Injector) {
        super(injector);

        this.webShopServiceProxy = injector.get(WebShopServiceProxy);
        this._combineViewService = injector.get(CombineViewService);

        this.rowsAmount$ = this._combineViewService.rowsAmount$;

        this.rowsAmount$
            .pipe(
                takeUntil(this.destroy$) // Automatically unsubscribes when destroy$ emits
            )
            .subscribe((rows) => {
                if (this.rowsAmount === rows || !rows) {
                    return;
                }

                this.rowsAmount = rows;
            });
    }

    //#region Current Page
    private _currentPage = 0;

    // Getter for the `total` input property
    get currentPage(): number {
        return this._currentPage;
    }

    //#endregion Current Page

    set currentPage(value: number) {
        // Add logic to transform or validate input here
        this._currentPage = value ? value : 0; // Default to an empty array if the value is falsy
    }

    globalSearch(event?: any) {
        this.webshopService.showLoader();

        let order = this.webshopService.getOrder(event);

        //set current page
        const page = event?.event?.page ?? 0;
        this._combineViewService.setCurrentPage(page);

        const skip = event?.event?.first ?? 0;
        const take = event?.event?.rows ?? this.rowsAmount;

        this._combineViewService.globalSearch$(
            this.webshopService.globalSearchFilter
            , undefined
            , order
            , skip
            , take
        )
            .pipe(
                finalize(() => {
                    this.webshopService.hideLoader();
                    this.spinnerService.hide();
                })
            )
            .subscribe((result: PagedResultDtoOfArticleDto) => {
                if (this.primeng) {
                    this.primeng.totalRecordsCount = result.totalCount;
                } else {
                    this.primengTableHelper.totalRecordsCount = result.totalCount;
                }

                this.primengTableHelper.hideLoadingIndicator();
                this.spinnerService.hide();
            });
    }

    showFavorites() {
        this.webshopService.showFavorites();
    }

    protected _addToFavorite($event: Event, product: ArticleDto) {
        this.preventClick($event);

        this.webshopService.addToFavorite($event, product);
    }

    protected _removeFromFavorite($event: Event, product: ArticleDto) {
        this.preventClick($event);

        this.webshopService.removeFromFavorite($event, product.id);
    }

    protected _addItemToBasket(article: BasketArticleDto) {
        if (+article.quantity <= 0 || article.quantity === undefined) {

            return throwError('Item quantity = 0, change ');
        }

        const item = _.cloneDeep(article);
        this.webshopService.addItem(item);
        this.resetQuantity(article);
    }

}
